import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
import { createFeatureAppId } from './create-feature-app-id';
export const renderFeatureApp = (params, featureAppConfiguration, logger) => () => {
    const beforeCreate = (env) => {
        if (params) {
            const faContentService = env.featureServices['fa-content-service'];
            if (faContentService) {
                const modelAsString = Array.isArray(params.model)
                    ? params.model
                    : [params.model];
                const models = modelAsString
                    .map((path) => (path === null || path === void 0 ? void 0 : path.split('/')) || [])
                    .filter((path) => path.length === 3)
                    .map((path) => {
                    return {
                        carlineId: path[0],
                        salesgroupId: path[1],
                        trimId: path[2],
                    };
                });
                const tenant = params.tenant;
                const showroomNodeId = params.showroomNodeId;
                const dimensionImagesTrim = params.dimensionImagesTrim;
                const defaultTrim = params.defaultTrim;
                logger.debug(`open ctd with params ${JSON.stringify(params)}`);
                const content = {
                    models,
                    viewMode: 'layer',
                    tenant,
                    showroomNodeId,
                    layerWithoutHeader: true,
                    dimensionImagesTrim,
                    defaultTrim
                };
                faContentService.content = content;
            }
        }
        else {
            logger.warn('no content provided');
        }
    };
    return (React.createElement(FeatureAppLoader, Object.assign({ featureAppId: createFeatureAppId(featureAppConfiguration), featureAppName: featureAppConfiguration.name }, featureAppConfiguration, { beforeCreate: beforeCreate })));
};
//# sourceMappingURL=render-feature-app.js.map